/* eslint-disable @typescript-eslint/no-non-null-assertion */
// noinspection JSCheckFunctionSignatures

import { createEvent, createEffect, restore, attach, forward } from 'effector'
import { subscribeLoggerEffect } from 'src/infastruct/effector-utils/subscribe-sentry'
import { NextRouter } from 'next/router'

export const attachRouter = createEvent<NextRouter | null>()
export const $router = restore(attachRouter, null)

export const pushFx = attach({
    source: $router,
    effect: (router, param) => {
        return router!.push(param)
    }
})

export const backRouteFx = attach({
    source: $router,
    effect: (router) => {
        return router!.back()
    }
})

export const reloadPageFx = attach({
    source: $router,
    effect: (router) => {
        return router!.reload()
    }
})

export const callFetch = createEvent()

const fxFetch = createEffect({
    handler: () => Promise.resolve(1)
})
subscribeLoggerEffect(fxFetch)

forward({ from: callFetch, to: fxFetch })

forward({ from: fxFetch.done, to: pushFx.prepend(() => '/') })
